import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import InformationWindow from '../../../components/informationWindow/informationWindow'
import Button from '../../../components/ui/button'

import { addMaterialTags } from '../../../api/contributions'
import { createLocalizedPath } from '../../../utils/localizationHelpers'
import { setPageToReturnFromPayment } from '../../../store/common/commonSlice'
import paths from '../../../paths'
import './labelMenu.sass'

interface Props {
    setIsLabelMenuOpen: React.Dispatch<React.SetStateAction<boolean>>
    newLabels: string[]
    setNewLabels: React.Dispatch<React.SetStateAction<string[]>>
    isVideo: boolean
    materialId: number
    isNecessaryToBuyPro?: boolean
}

const LabelMenu: React.FunctionComponent<Props> = ({
    setIsLabelMenuOpen,
    newLabels,
    setNewLabels,
    isVideo = false,
    materialId,
    isNecessaryToBuyPro
}: Props) => {
    const [t] = useTranslation()
    const history = useHistory()
    const dispatch = useDispatch()
    const location = useLocation()

    const [inputValue, setInputValue] = useState('')
    const [dialogMessage, setDialogMessage] = useState('')
    const [isDialogOpen, setIsDialogOpen] = useState(false)

    const EnFrRuRegex = /[A-ZА-ЯЁÀ-ÿ0-9 '’-]/gi

    const setValidatedValue = (value: string) => {
        if (value.match(EnFrRuRegex)) {
            setInputValue(value.match(EnFrRuRegex).join('').replace(/\s+/g, ' '))
        } else {
            setInputValue('')
        }
    }

    // @ts-ignore
    const handleStopPropagation = (e) => {
        e.stopPropagation()
    }

    const handleClosePopup = () => {
        setIsLabelMenuOpen(false)
    }

    const handleAddLabelByEnter = (e: KeyboardEvent) => {
        if (e.key === 'Enter') {
            // @ts-ignore
            setNewLabels([...newLabels, inputValue.trim()])
            setInputValue('')
        }
    }

    const handleAddLabel = () => {
        if (inputValue.trim().length > 0) setNewLabels([...newLabels, inputValue.trim()])
        setInputValue('')
    }

    const handleDeleteLabelFromList = (item: string) => {
        setNewLabels([...newLabels.filter((value) => value != item)])
    }

    const handleSubmitLabels = () => {
        if (newLabels.length > 0) {
            addMaterialTags({ tags: JSON.stringify(newLabels), material_id: materialId })
                .then((res) => {
                    if (res.status === 'success') {
                        setDialogMessage(res.message)
                        setIsDialogOpen(true)
                    }
                })
                .catch((e) => {
                    setDialogMessage(e.message)
                    setIsDialogOpen(true)
                })
                .finally(() => {
                    setNewLabels([])
                    // setIsLabelMenuOpen(false)
                })
        }
    }

    return (
        <div className="labelMenu" onClick={handleClosePopup}>
            <div className="menuBlock" onClick={handleStopPropagation}>
                {!isNecessaryToBuyPro ? (
                    <>
                        <div className="descriptionWrapper">
                            <div>
                                <p className="menuHeader">{t('Enter your labels')}</p>
                                <div className="inputLine">
                                    {newLabels.length < 3 ? (
                                        <>
                                            <input
                                                className="addLabel"
                                                type="text"
                                                autoComplete="off"
                                                value={inputValue}
                                                onChange={(e) => setValidatedValue(e.target.value)}
                                                // @ts-ignore
                                                onKeyDown={handleAddLabelByEnter}
                                                // onSubmit={() => alert(inputValue)}
                                            />
                                            <Button label={'+'} onClick={handleAddLabel} />
                                        </>
                                    ) : (
                                        <div className="stopAddLabels">{t('You can add only 3 labels')}</div>
                                    )}
                                </div>
                            </div>
                            <div>
                                {newLabels.map((item) => (
                                    <div className="labels" key={item} onClick={() => handleDeleteLabelFromList(item)}>
                                        {item}
                                    </div>
                                ))}
                            </div>

                            <div className="labelInfo">
                                <p>
                                    {t(
                                        'Participate in the labelling of photos and videos by writing a few words to describe them'
                                    )}
                                    .
                                </p>
                                <p>{t('Suggest labels')}:</p>
                                <p>- {t('Directly related to the content of the photo or video')}</p>
                                <p>- {t('Only for the photos and videos of very good quality')}</p>
                                <p>- {t('Only for photos in which the faces are not hidden')}</p>
                                {/*<p>{t('Please read the existing labels and dont repeat those')}</p>*/}
                            </div>
                        </div>
                        <div className="buttonLine">
                            <Button label={t('Add labels')} onClick={handleSubmitLabels} />
                            <Button label={t('Cancel')} onClick={handleClosePopup} />
                        </div>
                    </>
                ) : (
                    <div className="paymentDialog">
                        <div>
                            <p className="menuHeader">{t('You must be a Premium member to label this photo')}</p>
                        </div>
                        <div className="buttonLine">
                            <Button
                                label={t('Become Premium')}
                                onClick={() => {
                                    history.push(createLocalizedPath(paths.payment.path))
                                    dispatch(setPageToReturnFromPayment(location.pathname))
                                }}
                            />
                            <Button label={t('Cancel')} onClick={handleClosePopup} />
                        </div>
                    </div>
                )}
                {/*<p className="thank">*/}
                {/*    {isVideo ? t('Thank you for labeling this video') : t('Thank you for labeling this photo')}*/}
                {/*</p>*/}
                <div className={'closeButton'} onClick={handleClosePopup} />
            </div>

            <InformationWindow
                informationText={dialogMessage}
                setExternalState={setIsLabelMenuOpen}
                externalState={isDialogOpen}
                labelFunctionalButton={t('Ok')}
            />
        </div>
    )
}

export default LabelMenu
